import Constant from '../model/Constant'
import BaseDateData from './BaseDateData'

export default {
  extends: BaseDateData,
  data: () => ({
    query: {
      siteIds: [],
      isAuditCompleted: false,
      isGetInvalidData: true,
      isMultipleIntegral: true
    },
    currentQuery: Object.freeze({}),
    dataList: Object.freeze([]),
    noDataList: Object.freeze([])
  }),
  computed: {
    siteDeviceCategoryConfig: () => [],
    minSiteSelectNumber: () => 1,
    completeAllData: () => false,
    valueProp: () => 'value',
    requestNoDataInfo: () => true,
    _siteDeviceCategoryConfig () {
      let bit = 0
      return this.siteDeviceCategoryConfig.reduce((map, deviceCategoryConfig) => {
        let {categoryId} = deviceCategoryConfig
        let num = 1 << bit

        if (!map.map[categoryId]) {
          map.map[categoryId] = {
            bit: bit,
            filter: deviceCategoryConfig.filter
          }
          map.total |= num
          map.min |= num & (-deviceCategoryConfig.required)
          bit++
        }

        return map
      }, {
        map: {},
        total: 0,
        min: 0
      })
    },
    _filterSites () {
      let {profileSiteDevices} = this

      if (profileSiteDevices.length === 0) {
        return []
      }

      let {_siteDeviceCategoryConfig: {map: deviceCategoryMap, total, min}, profileSiteMap} = this

      return Object.values(profileSiteDevices.reduce((map, siteDevice) => {
        let {siteId} = siteDevice
        let site = profileSiteMap[siteId]

        if (!site) {
          return map
        }

        let deviceCategoryConfig = deviceCategoryMap[siteDevice.categoryId]

        if (deviceCategoryConfig) {
          let {filter} = deviceCategoryConfig
          let siteDeviceFactors = filter instanceof Function
            ? filter(siteDevice.siteDeviceFactors, siteDevice)
            : [...siteDevice.siteDeviceFactors]

          if (siteDeviceFactors.length > 0) {
            let {bit} = deviceCategoryConfig
            let tmpSite = map[siteId]

            if (!tmpSite) {
              tmpSite = map[siteId] = {
                id: siteId,
                name: site.name,
                total: 0,
                devices: []
              }
            }

            tmpSite.total |= 1 << bit
            tmpSite.devices.push({
              ...siteDevice,
              siteDeviceFactors
            })
          }
        }

        return map
      }, {})).filter(site => (site.total & total) >= min)
    },
    filterSites () {
      return this._filterSites
    },
    filterSiteMap () {
      return this.filterSites.reduce((map, site) => {
        map[site.id] = site
        return map
      }, {})
    },
    isNoSelectedSites () {
      return this.query.siteIds.length === 0
    },
    canNotSearch () {
      return this.isNoSelectedSites
    },
    noDataReasonMap () {
      return this.noDataList.reduce((map, noData) => {
        map[`${noData.siteId}-${noData.siteDeviceId}-${noData.dataTime}:00:00`] = noData
        return map
      }, {})
    }
  },
  methods: {
    setOther () {
      return true
    },
    setDataList (dataList) {
      this.tmpList = Object.freeze(dataList)
      this.formatData()
    },
    setNoDataList (noDataList) {
      const {NO_DATA_REASON_MAP} = Constant

      this.noDataList = Object.freeze(noDataList.map(noData => {
        let {cause} = noData
        const noDataReasons = []

        while (cause > 0) {
          const bin = -cause & cause
          cause ^= bin
          const noDataReason = NO_DATA_REASON_MAP[bin]

          if (noDataReason) {
            noDataReasons.push(noDataReason.label)
          }
        }

        return {
          ...noData,
          reason: noDataReasons.join(',')
        }
      }))
    },
    setAllDataList ([dataList, noDataList]) {
      this.setNoDataList(noDataList)
      this.setDataList(dataList)
    },
    setSiteIds () {
      let {filterSites} = this

      if (filterSites.length === 0) {
        return
      }

      let {query: {siteIds}} = this

      if (siteIds.length === 0) {
        siteIds.push(...filterSites.slice(0, this.minSiteSelectNumber).map(site => site.id))
      }

      this.afterSetSiteIds()
    },
    afterSetSiteIds () {
      if (this.setOther()) {
        this.setCurrentQuery()
        this.getData()
      }
    },
    setCurrentQuery () {
      this.currentQuery = Object.freeze(JSON.parse(JSON.stringify(this.query)))
    },
    getData () {
      if (!this.currentQuery.siteIds.length) {
        this.dataList = []
        return
      }
      this.changeLoadStatus(true)
      const {currentQuery} = this

      const requests = [
        this.$api.Data.getHistoryData(currentQuery)
      ]

      let successCallback = this.setDataList

      if (this.requestNoDataInfo) {
        requests.push(this.$api.NoData.getNoDataListBySite(currentQuery))
        successCallback = this.setAllDataList
      }

      Promise.all(requests).then(successCallback).catch(console.error).finally(() => {
        this.changeLoadStatus(false)
      })
    },
    onAuditCompletedChanged () {
      let {query} = this
      query.isAuditCompleted ? query.isGetInvalidData = false : query.isGetInvalidData = true
      if (query.isAuditCompleted === 'isFuse') {
        query.isFuse = true
        delete query.isAuditCompleted
      } else {
        query.isFuse = false
      }
      this.afterSetSiteIds()
    },
    onSearchBtnClick () {
      this.afterSetSiteIds()
    }
  },
  watch: {
    filterSites (filterSites) {
      this.setSiteIds()
    }
  },
  created () {
    this.setSiteIds()
  }
}



// WEBPACK FOOTER //
// ./src/views/BaseSiteDeviceData.js